const Configuration = (() => {
    const OCI_ASSETS = "https://assets-usoft.universalsoft.net"

    const dev = {
        API: "https://srv-prod.usoft-api88.net/admin-bo/api",
        ASSETS: OCI_ASSETS,
        GATEWAYAPI: "https://srv-prod-bonus-ca.apiusoft.com",
    }
    const local = {
        // API: "http://localhost:5000/api",
        API: "https://srv-prod.usoft-api88.net/admin-bo/api",
        GATEWAYAPI: "https://srv-prod-bonus-ca.apiusoft.com",
        ASSETS: OCI_ASSETS,
    }
    const prod = {
        // API: "http://localhost:5000/api",
        API: "https://srv-prod.usoft-api88.net/admin-bo/api",
        ASSETS: OCI_ASSETS,
        GATEWAYAPI: "https://srv-prod-bonus-ca.apiusoft.com",
    }

    const configMap = new Map()
    configMap.set("local", local)
    configMap.set("dev", dev)
    configMap.set("prod", prod)


    const getEnv = () => {
        const host = null?window.location.toString():'';
        const env = /localhost|127.0.0.1/.test(host) ? 'local' : /dev/.test(host) ? 'dev' : 'prod';
        console.log("YOU ARE ON "+env);
        return env;
    }

    const getConfiguration = () => {
        const env = getEnv()
        const config = configMap.get(env)
        return config
    }
    return { getConfiguration, getEnv }
})()

export default Configuration
